import { ReactNode } from 'react'
// Logic
import { useWapp } from '$logic/wapps/react-hook'
// Helpers
import { getImageUrl } from '$func/imageUrl'
import { stringToColor } from '$func/string-to-color'
import { useWappRoom } from '$logic/wapp-room/react-hook'
import { getAvatarText } from '$func/avatar-text'
import { SelectableAvatar, SelectableAvatarProps } from '$common/avatar'

interface WappAvatarProps
  extends Omit<SelectableAvatarProps, 'avatarBackgroundText' | 'src'> {
  wappId: string
  children?: ReactNode
}

export function WappAvatar({
  wappId,
  onClick,
  children,
  ...rest
}: WappAvatarProps) {
  const { entity: wappRoom } = useWappRoom(wappId)
  const { entity: wapp } = useWapp(wappId)
  const backgroundColor = stringToColor(wapp?.name, wappRoom?.roomId)
  const src = getImageUrl(wapp?.image)
  return (
    <SelectableAvatar
      avatarBackgroundText={children || getAvatarText(wapp?.name)}
      src={src}
      alt={wapp?.name?.toUpperCase()}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
      backgroundColor={backgroundColor}
      {...rest}
    />
  )
}
